import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import AddDoctorModal from './AddDoctorModal';
import DeleteDoctorModal from './DeleteDoctorModal';  // Import DeleteDoctorModal
import DoctorsTable from './DoctorsTable';
import { FaPlus } from 'react-icons/fa';
import Sidebar from "../../components/Sidebar";
import TopNavbar from "../../components/TopNavbar";
import axios from 'axios';

const Doctors = () => {
    const [doctors, setDoctors] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);  // Track delete modal state
    const [currentDoctor, setCurrentDoctor] = useState(null);
    const [doctorToDelete, setDoctorToDelete] = useState(null);  // Track the doctor to delete

    useEffect(() => {
        // Fetch doctors from the backend when the component mounts
        const fetchDoctors = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get('https://horizontclinic.com/horizont-be/getDoctors.php', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (response.data.status === 'success') {
                    setDoctors(response.data.doctors);
                } else {
                    console.error(response.data.message);
                }
            } catch (error) {
                if (error?.response?.status === 401) {
                    localStorage.removeItem('token');
                    window.location.href = '/login';
                    return;
                }
                console.error('Error fetching doctors:', error);
            }
        };

        fetchDoctors();
    }, []);

    const handleAddDoctor = () => {
        setCurrentDoctor(null);  // Clear the current doctor when adding a new one
        setIsModalOpen(true);
    };

    const handleSubmitDoctor = async (doctorData) => {
        console.log("Doctor Data on Submit:", doctorData); // Log to verify `id` is present
        
        try {
            if (doctorData.id) { // If `id` exists, it’s an edit action
                const token = localStorage.getItem('token');
                const response = await axios.post('https://horizontclinic.com/horizont-be/editDoctor.php', doctorData, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    },
                });
    
                if (response.data.status === 'success') {
                    // Update doctor in the doctors list
                    setDoctors(doctors.map(doc => (doc.id === doctorData.id ? response.data.doctor : doc)));
                } else {
                    console.error(response.data.message);
                }
            } else {
                // Add new doctor action
                const token = localStorage.getItem('token');
                const response = await axios.post('https://horizontclinic.com/horizont-be/addDoctor.php', doctorData, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    },
                });
    
                if (response.data.status === 'success') {
                    setDoctors([...doctors, response.data.doctor]); // Add the new doctor to the list
                } else {
                    console.error(response.data.message);
                }
            }
        } catch (error) {
            console.error('Error submitting doctor:', error);
        }
    
        setIsModalOpen(false); // Close the modal after adding or updating
    };
    
    
    const handleEditDoctor = (doctor) => {
        setCurrentDoctor(doctor);
        setIsModalOpen(true);
    };

    // Open delete confirmation modal
    const handleDeleteDoctor = (doctor) => {
        setDoctorToDelete(doctor);
        setIsDeleteModalOpen(true);
    };

    // Confirm and delete the doctor
    const confirmDeleteDoctor = async (doctorId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('https://horizontclinic.com/horizont-be/deleteDoctor.php', { id: doctorId }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.status === 'success') {
                setDoctors(doctors.filter(doctor => doctor.id !== doctorId));
                setIsDeleteModalOpen(false);  // Close modal after deletion
            } else {
                console.error(response.data.message);
            }
        } catch (error) {
            console.error('Error deleting doctor:', error);
        }
    };

    return (
        <div className="d-flex">
            {/* Sidebar */}
            <Sidebar />

            {/* Main Content Area */}
            <div className="flex-grow-1">
                {/* Top Navbar */}
                <TopNavbar />
                <div className={'container pt-5'}>
                    <div className="mb-4 px-3 d-flex justify-content-between align-items-center">
                        <h1>Doctors</h1>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<FaPlus />}
                            onClick={handleAddDoctor}
                        >
                            Add Doctor
                        </Button>
                    </div>

                    <DoctorsTable
                        doctors={doctors}
                        onEdit={handleEditDoctor}
                        onDelete={handleDeleteDoctor}  // Use new delete handler
                    />

                    <AddDoctorModal
                        open={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        onSubmit={handleSubmitDoctor}
                        initialData={currentDoctor || {}}
                    />

                    {/* Delete Confirmation Modal */}
                    <DeleteDoctorModal
                        open={isDeleteModalOpen}
                        onClose={() => setIsDeleteModalOpen(false)}
                        onDelete={confirmDeleteDoctor}  // Call confirm delete function
                        doctor={doctorToDelete}  // Pass the doctor to be deleted
                    />
                </div>
            </div>
        </div>
    );
};

export default Doctors;
